import { Pipe, PipeTransform } from '@angular/core';
import { SessionUserRole } from '../helpers/enums/enums';
import { getRoleIdFromParticipant, isDisplayVideoTile } from '../helpers/utils';
import { Participant, ParticipantType } from '../interfaces/participant.interface';
import { LoggerService } from '../services/logger.service';


@Pipe({
    name: 'sessionPipe'
})
export class SessionPipe implements PipeTransform {

    constructor(private readonly logger: LoggerService) { }

    transform(val: any, type: string, param1?: any, param2?: any) {
        try {
            switch (type) {
                case 'isFileInProcess': {
                    let isProcess = false;
                    try {
                        const session = val;
                        isProcess = session.sessionRecording.filter(sr => sr.rec.some(sre => (!sre.isUploaded || sre.state !== 'complete'))).length > 0;
                    } catch (error) { }
                    return isProcess;
                }
                case 'isSpeakingCamOff': {
                    return param2 ? (val ? `0px 0px 56px ${param1 ? param1 : '#f17a7e85'}` : '')
                        : (val ? `3px solid ${param1 ? param1 : '#ff989cb3'}` : '8px solid #657f82');
                }
                case 'isSpeakingCamOn': {
                    return param2 ? (val ? `0px 0px 0px 4px ${param1 ? param1 : '#f17a7e'}` : '')
                        : (val ? `3px solid ${param1 ? param1 : '#ff989cb3'}` : '0px solid #657f82');
                }
                case 'isAudience': {
                    const participant: Participant = val;
                    if (!participant.isWaiting) {
                        const roleId = getRoleIdFromParticipant(participant);
                        return SessionUserRole.audience === roleId
                    }
                }
                case 'isConfUser': {
                    const participant: Participant = val;
                    const roleId = getRoleIdFromParticipant(participant);
                    if (SessionUserRole.guest === roleId || SessionUserRole.host === roleId) {
                        return true;
                    }
                }
                case 'displayVideoTile': {
                    try {
                        const participant: Participant = val;
                        // console.log('displayVideoTile', participant)
                        // const currentParticipantId = param1;
                        // console.log('displayVideoTile currentParticipantId', currentParticipantId)
                        // if (participant.id === currentParticipantId) {
                        //     console.log('displayVideoTile currentParticipantId =', currentParticipantId)
                        //     return true;
                        // }
                        // if (participant.isWaiting) {
                        //     console.log('displayVideoTile isWaiting')
                        //     return false;
                        // }
                        return isDisplayVideoTile(participant)
                    } catch (error) {
                        this.logger.error('displayVideoTile', error);
                    }
                    return false;
                }

                case 'layoutClass': {
                    if(!val) return '';
                    let layoutCls = val;
                    console.log('layout-class', layoutCls)
                    if (layoutCls === '53') layoutCls = '51';
                    layoutCls = `user${layoutCls[0]}-${layoutCls[1]}`
                    console.log('layout-class after', layoutCls)
                    return layoutCls
                }
            }
        } catch (error) {
            this.logger.error('SessionPipe', error);
        }
    }
}